import React from "react";
import { useQuery } from "@tanstack/react-query";
import LookupTableParameterEdit from "components/lookup-table-parameters/LookupTableParameterEdit";
import { fetchAllLookupTables } from "components/lookup-tables/hooks/api/lookupTablesAPI";
const LookupTableQueryParameterEdit = ({ parameter, onChange, identifier, validationState = void 0 }) => {
  const { data: tables = [] } = useQuery({
    queryKey: ["lookup-tables", "all"],
    queryFn: () => fetchAllLookupTables()
  });
  return /* @__PURE__ */ React.createElement(
    LookupTableParameterEdit,
    {
      lookupTables: tables,
      parameter,
      onChange,
      identifier,
      validationState
    }
  );
};
export default LookupTableQueryParameterEdit;
